import React from 'react';
import { Configuration } from '../../../configs/Configuration';

export default function BCLLoading(){
  const loadingIcon = Configuration.getConfiguration().loadingIcon;
  return(
    <div className="loading-screen">
      <img src={require(`../../../assets/img/${loadingIcon}`)} alt="Loading"/>
    </div>
  )
}
